<script setup lang="ts">
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import TeamInvitationModal from '@/components/TeamInvitationModal.vue'
import { defineAsyncComponent } from 'vue'
import { RouterView } from 'vue-router'
import FeatureGuide from './components/FeatureGuide/FeatureGuide.vue'
import FeedbackWidget from './components/Feedback/FeedbackWidget.vue'
import UpgradeModal from './components/Modal/UpgradeModal/UpgradeModal.vue'
import NitNotification from './components/NitNotification.vue'
import { isLoggedIn, uid } from './firebase'
import { hasQuery } from './helpers/hasQuery'
import { Mixpanel } from './helpers/mixpanel'
import { useNetworkStatus } from './hooks/useNetworkStatus'
import { useRouteQueryNotification } from './hooks/useRouteQueryNotification'
import { useCalendarAccountsStore } from './store/calendarAccountsStore'
import { useBookingMailTemplatesStore } from './store/bookingMailTemplatesStore'
import { useFormsStore } from './store/formsStore'
import { useNotFoundStore } from './store/notFoundStore'
import { usePagesStore } from './store/pagesStore'
import { useSettingStore } from './store/settingStore'
import { useTeamStore } from './store/teamStore'
import { useActivityStatusStore } from './store/userActivityStatusStore'
import { useImportantNoticeStore } from './store/importantNoticeStore'
import { useUserPlanStore } from './store/userPlanStore'
import { useUserStore } from './store/userStore'

// 動的インポートに変更してCode Splittingを有効化
const Navigation = defineAsyncComponent(
  () => import('@/pages/Home/common/Navigation/Navigation.vue')
)
const NotFound = defineAsyncComponent(() => import('./pages/NotFound.vue'))

if (isLoggedIn()) {
  useUserStore().setup()
  useUserPlanStore().setup()
  useSettingStore().setup()
  useCalendarAccountsStore().setup()
  useTeamStore()
    .setup()
    // TeamsStoreに依存するので
    .then(() =>
      Promise.all([
        useFormsStore().setup(), // firstTeamに依存
        useBookingMailTemplatesStore().setup(), // firstTeamに依存
        usePagesStore().setup() // teamIdsに依存
      ])
    )
  useActivityStatusStore().setup()
  useImportantNoticeStore().setup()

  Mixpanel.identify()
}
useRouteQueryNotification()
useNetworkStatus()

const notFoundStore = useNotFoundStore()
</script>
<template>
  <NotFound v-if="notFoundStore.notFound" />
  <template v-else>
    <Navigation v-if="$route.meta.showHeader" />
    <router-view />
    <NitNotification />
    <!-- ランディングしたページに関わらず表示したいのでここに書いておく -->
    <TeamInvitationModal />
    <!-- プロプランのフリートライアルが切れた時に使っている -->
    <UpgradeModal :plan="'auto'" :default-shown="hasQuery('upgrade', '1')" />
    <!-- ?guide_target=<selector>&guide_title=...&guide_desc=... で新機能をガイド表示 -->
    <FeatureGuide />
    <FeedbackWidget :uid="uid()" />
  </template>
</template>
<style>
/* Google Fontsはmain.tsでセルフホスティング（パフォーマンス最適化） */
@import './styles/color.css';
@import './styles/font.css';
@import './styles/global.css';
@import './styles/layout.css';
@import './styles/grid.css';
@import './styles/margin.css';
@import './styles/padding.css';
@import './styles/border.css';
@import './styles/background.css';
@import './styles/shadow.css';
@import './styles/reset.css';
@import './styles/utility.css';
@import './styles/z_index.css';
@import './styles/modal.css';
@import './styles/featureGuide.css';
</style>
